import {
    Outlet,
    Navigate,
    useLocation
} from "react-router-dom"
import styles from "./Main.module.css"

// import Sidebar from "@/components/layout/Sidebar/Sidebar"
import { Navbar } from '@/components/layout'
import { ROUTES } from '@/constants'

export function Main() {
    const location = useLocation()

    // Redirect to home if path is exactly '/'
    if (location.pathname === ROUTES.main) {
        return <Navigate to={ROUTES.home} replace />
    }

    return (
        <div className={styles.container}>
            {/* <Sidebar /> */}
            <Navbar />
            <div className={styles.contentWrapper}>
                <Outlet />
                {/* <Footer /> */}
            </div>
        </div>
    )
}
